<div #container class="avatar-container">
  <video #video width="640" height="480" autoplay muted></video>
</div>
